/*eslint-disable */
import React from "react";

interface AsistenciaComponentProps {
  assistances: any;
}

const AsistenciaComponent: React.FC<AsistenciaComponentProps> = ({
  assistances,
}) => {
  return (
    <>
      {/* H2 - Título de la sección (comentado pero disponible) */}
      {/* <h2 className="title-posventa-asistecia-component">Asistencia</h2> */}
      
      <div className="servicios-posventa-asistecia-container">
        {assistances?.map((item: any, index: number) => (
          <div
            key={index}
            className={`contenido-servicios-posventa-asistecia-container ${item?.format === "left" ? "anormal" : ""}`}
          >
            <div className="img-contenido-servicios-posventa-asistecia-container">
              <img 
                src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} 
                alt={item?.title ? item.title : "Imagen de asistencia"} 
              />
            </div>
            
            <div className="text-contenido-servicios-posventa-asistecia-container">
              {/* H3 - Título del servicio */}
              <h3 className="title">{item?.title}</h3>
              
              {/* H4 - Descripción del servicio (como subtítulo) */}
              <h4 
                className="description" 
                dangerouslySetInnerHTML={{ __html: item?.description }}
              ></h4>
              
              {/* <div className="btn">Ver más</div> */}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default AsistenciaComponent;